import { GlAlert, GlSprintf } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import HelpPageLink from '../../../../../../../app/assets/javascripts/vue_shared/components/help_page_link/help_page_link.vue?vue3';
import { FLOW_TRIGGER_TYPE_SCHEDULE } from 'ee/ai/duo_agents_platform/constants';
import { AI_CATALOG_TYPE_AGENT, AI_CATALOG_TYPE_FLOW, AI_CATALOG_TYPE_THIRD_PARTY_FLOW, AI_CATALOG_ITEM_CONSUMER_DISCLAIMER_TEXTS } from '../constants';
export default {
    name: 'AiCatalogItemConsumerDisclaimer',
    components: {
        GlAlert,
        GlSprintf,
        HelpPageLink
    },
    inject: {
        isGroupNamespace: {}
    },
    props: {
        itemType: {
            type: String,
            required: true,
            validator: (value)=>[
                    AI_CATALOG_TYPE_AGENT,
                    AI_CATALOG_TYPE_FLOW,
                    AI_CATALOG_TYPE_THIRD_PARTY_FLOW
                ].includes(value)
        },
        canEnable: {
            type: Boolean,
            required: false,
            default: false
        },
        triggerTypes: {
            type: Array,
            required: false,
            default: ()=>[]
        }
    },
    computed: {
        disclaimerTexts () {
            return AI_CATALOG_ITEM_CONSUMER_DISCLAIMER_TEXTS[this.itemType];
        },
        isAgent () {
            return this.itemType === AI_CATALOG_TYPE_AGENT;
        },
        hasScheduledTrigger () {
            return this.triggerTypes.includes(FLOW_TRIGGER_TYPE_SCHEDULE.value);
        },
        hasEventTrigger () {
            return this.triggerTypes.some((type)=>type !== FLOW_TRIGGER_TYPE_SCHEDULE.value);
        },
        // Returns null when no trigger is selected, so nothing renders until there is
        // something to describe.
        flowDisclaimer () {
            if (this.hasScheduledTrigger && this.hasEventTrigger) {
                return this.disclaimerTexts.combinedAccess;
            }
            if (this.hasScheduledTrigger) {
                return this.disclaimerTexts.scheduleAccess;
            }
            if (this.hasEventTrigger) {
                return this.disclaimerTexts.compositeIdentity;
            }
            return null;
        }
    }
};
